export enum DonationsRoutePath {
    Donations = '/donations',
    DonationsIncomeCreate = '/donations/income/create',
    DonationsIncomeUpdate = '/donations/income/update/:idTransaction',
    DonationsExpenseCreate = '/donations/expense/create',
    DonationsExpenseUpdate = '/donations/expense/update/:idTransaction',
    DonationsOrganizationCreate = '/donations/organization/income/create',
    DonationsOrganizationUpdate = '/donations/organization/income/update/:idTransaction',
    DonationsOrganization = '/donations/organization',
    DonationsOrganizationDetail = '/donations/organization/:id',
    DonationsOrganizationCreateDonationIncome = '/donations/organization/:id/income/create',
    DonationsOrganizationUpdateDonationIncome = '/donations/organization/:id/income/update/:idTransaction',
    DonationsOrganizationCreateDonationExpense = '/donations/organization/:id/expense/create',
    DonationsOrganizationUpdateDonationExpense = '/donations/organization/:id/expense/update/:idTransaction',
    DonationsIndividual = '/donations/individual',
    DonationsIndividualDetail = '/donations/individual/:id'
}
